<template>
  <div
    id="nav-container"
    class="w-full"
  >
    <div class="flex flex-col items-end ml-2">
      <div class="w-full">
        <vetster-side-nav-link
          v-for="category in categories"
          :key="snakeCase(get(category, titleKey))"
          :is-refresh="isRefresh"
          :active-nav="activeNav"
          :href="`#${snakeCase(get(category, titleKey))}`"
          :icon="getIconName(get(category, 'slug')) ? getIconName(get(category, 'slug')) : 'angle-right'"
          :label="getLabel(get(category, titleKey))"
          :nav-id="snakeCase(get(category, titleKey))"
          @click="navigateToSection(snakeCase(get(category, titleKey)))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import VetsterSideNavLink from '@/components/VetsterSideNavLink';
import { snakeCase } from '@/helpers/format';
import HasNavMenu from '@/mixins/HasNavMenu';

const Icons = {
  'new-pet': 'sparkles',
  safety: 'shield',
  travel: 'route',
  gifts: 'gift',
  stress: 'siren-on',
  'key-takeaways': 'key',
  'a-closer-look': 'file-search',
  'connect-with-a-vet': 'user-md',
  'risk-factors': 'exclamation-triangle',
  'possible-causes': 'file-medical',
  references: 'books',
  'testing-and-diagnosis': 'stethoscope',
  'similar-symptoms': 'file-medical',
  'associated-symptoms': 'file-medical',
  'editorial-committee': 'users',
  'more-information': 'info-circle',
  dog: 'dog',
  cat: 'cat',
  horse: 'horse',
  turtle: 'turtle',
  bird: 'bird',
  'avoid-cat-astrophes': 'sparkles',
  'book-an-online-vet': 'sparkles',
  top: 'arrow-up-to-line',
  survey: 'square-poll-vertical',
  articles: 'newspaper',
  next_steps: 'signs-post',
  'what-is-drug': 'prescription',
  'how-it-works': 'file-prescription',
  'how-is-it-given': 'file-prescription',
  'side-effects': 'exclamation-triangle',
  'safety-overdose': 'hand-holding-medical',
  'missed-dosage': 'prescription-bottle-medical',
  'drug-interaction': 'file-medical',
  'alternatives-to-drug': 'prescription-bottle-pill',
  'associated-conditons': 'stethoscope',
  'medications-and-treatments': 'prescription-bottle-pill',
  'conditions-to-manage': 'stethoscope',
  'concerned-about-a-symptom': 'stethoscope',
  'what-can-and-cannot-eat': 'clipboard-question',
  'what-is-the-veterinarian-role': 'user-doctor',
  'how-to-keep-your-companion-healthy': 'hand-holding-medical',
  'dog-breeds': 'dog',
  'symptoms-conditions-behavior': 'stethoscope',
  'history-of-breed': 'book-medical',
  'quick-facts': 'file-magnifying-glass',
  'are-breed-right-for-you': 'clipboard-question',
};

export default {
  name: 'VetsterSideScroll',

  components: { VetsterSideNavLink },

  mixins: [HasNavMenu],

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    document.addEventListener('scroll', this.scrollHandler);
  },

  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollHandler);
  },

  methods: {
    getIconName(key) {
      return Icons[key] || '';
    },
    navigateToSection(id) {
      window.scrollTo({
        top: document.getElementById(id).getBoundingClientRect().top + window.pageYOffset - 120,
        behavior: 'smooth',
      });
    },
    scrollHandler() {
      document.querySelectorAll('.post').forEach((el) => {
        const condition = el.getBoundingClientRect().top < 150
          && el.getBoundingClientRect().top >= -el.getBoundingClientRect().height;

        if (condition) {
          this.activeNav = `#${el.id}`;
        }
      });
    },
    get,
    snakeCase,
  },
};
</script>
